import { supabase } from '../../lib/supabase'
import type { CampaignCreatorStatus } from '../../types'

export const campaignParticipationProvider = {
  async listForOperator(campaignId: string) {
    return supabase
      .from('campaign_creators')
      .select('id,owner_user_id,status,invited_at,confirmed_at,status_reason,client_visible,fee_amount,created_at,creator:creators(id,source_key,full_name,email,phone,primary_platform,primary_handle,followers_count)')
      .eq('campaign_id', campaignId)
      .order('created_at', { ascending: false })
  },

  async transition(input: { campaignCreatorId: string; targetStatus: CampaignCreatorStatus; reason: string }) {
    return supabase.rpc('transition_campaign_participation', {
      p_campaign_creator_id: input.campaignCreatorId,
      p_target_status: input.targetStatus,
      p_reason: input.reason,
    })
  },

  async setClientVisibility(input: { campaignCreatorId: string; clientVisible: boolean; reason: string }) {
    return supabase.rpc('set_campaign_participant_visibility', {
      p_campaign_creator_id: input.campaignCreatorId,
      p_client_visible: input.clientVisible,
      p_reason: input.reason,
    })
  },

  async previewAssignment(deliverableId: string, campaignCreatorIds: string[] | null = null) {
    return supabase.rpc('preview_campaign_assignment', {
      p_deliverable_id: deliverableId,
      p_campaign_creator_ids: campaignCreatorIds,
    })
  },

  async bulkAssign(deliverableId: string, campaignCreatorIds: string[] | null = null) {
    return supabase.rpc('bulk_assign_campaign_participants', {
      p_deliverable_id: deliverableId,
      p_campaign_creator_ids: campaignCreatorIds,
    })
  },

  async listClientParticipants(campaignId: string) {
    return supabase.rpc('list_client_campaign_participants', { p_campaign_id: campaignId })
  },
}
